import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.support.announcements');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-support-announcements',
template: templateSource || '',
    styles: [``],
})
export class PortalLpsysadminSupportAnnouncementsComponent implements OnInit {
    @Input() program_id: string = '';   // 지원사업 상세 탭에서 호출 시 주입

    constructor(@Inject( Service) public service: Service) { }

    public items: any[] = [];
    public loaded: boolean = false;
    public statusFilter: string = '';
    public searchText: string = '';

    public statusMap: any = {
        draft: { label: '작성중', cls: 'bg-zinc-100 text-zinc-600' },
        scheduled: { label: '예정', cls: 'bg-amber-100 text-amber-700' },
        open: { label: '접수중', cls: 'bg-emerald-100 text-emerald-700' },
        closed: { label: '마감', cls: 'bg-zinc-300 text-zinc-700' },
        archived: { label: '보관', cls: 'bg-zinc-200 text-zinc-500' },
    };

    // 신청 사이트 base URL (apply 프로젝트 — 추후 config 화)
    public APPLY_BASE_URL: string = '/apply/f';

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public statusInfo(s: string) {
        return this.statusMap[s] || { label: s || '-', cls: 'bg-zinc-100 text-zinc-600' };
    }

    public async load() {
        this.loaded = false;
        await this.service.render();
        const { code, data } = await wiz.call('search', {
            program_id: this.program_id,
            status: this.statusFilter,
            text: this.searchText,
        });
        if (code == 200) {
            this.items = data.rows || [];
        }
        this.loaded = true;
        await this.service.render();
    }

    public publicUrl(item: any): string {
        return `${this.APPLY_BASE_URL}/${item.slug}`;
    }

    public async copyUrl(item: any) {
        const url = window.location.origin + this.publicUrl(item);
        try {
            await navigator.clipboard.writeText(url);
            await this.service.alert.show({ title: '복사 완료', message: url, action: '확인', actionBtn: 'primary' });
        } catch (e) {
            await this.service.alert.show({ title: '복사 실패', message: url, action: '확인', actionBtn: 'primary' });
        }
    }

    public openEditor(id: string = 'new') {
        // /admin/support/programs/{program_id}/announcements/{id|new}
        const pid = this.program_id;
        if (pid) {
            this.service.href(`/admin/support/programs/${pid}/announcements/${id}`);
        } else {
            this.service.href(`/admin/support/announcements/${id}`);
        }
    }

    public async createNew() {
        // 빠른 등록: 제목만 입력받고 editor로 이동
        const title = prompt('새 모집공고 제목을 입력하세요');
        if (!title) return;
        const { code, data, message } = await wiz.call('create', {
            data: JSON.stringify({
                program_id: this.program_id,
                title: title,
                status: 'draft',
            }),
        });
        if (code !== 200) {
            await this.service.alert.show({ title: '생성 실패', message: message || '오류', action: '확인', actionBtn: 'error' });
            return;
        }
        this.openEditor(data.id);
    }

    public async toggleStatus(item: any) {
        // draft <-> open 토글 (간이)
        const next = item.status === 'open' || item.status === 'scheduled' ? 'draft' : 'open';
        const ok = await this.service.alert.show({
            title: '상태 변경',
            message: `"${item.title}" 공고를 ${next === 'open' ? '게시(접수 시작)' : '비공개(작성중)'}로 전환하시겠습니까?`,
            action: '변경', actionBtn: 'primary', cancel: '취소',
        });
        if (!ok) return;
        const { code, message } = await wiz.call('update', {
            id: item.id,
            data: JSON.stringify({ status: next }),
        });
        if (code !== 200) {
            await this.service.alert.show({ title: '실패', message: message || '오류', action: '확인', actionBtn: 'error' });
            return;
        }
        await this.load();
    }

    public async remove(item: any) {
        const ok = await this.service.alert.show({
            title: '공고 삭제',
            message: `"${item.title}" 공고를 삭제하시겠습니까?`,
            action: '삭제', actionBtn: 'error', cancel: '취소',
        });
        if (!ok) return;
        const { code, message } = await wiz.call('remove', { id: item.id });
        if (code !== 200) {
            await this.service.alert.show({ title: '삭제 실패', message: message || '오류', action: '확인', actionBtn: 'error' });
            return;
        }
        await this.load();
    }
}

export default PortalLpsysadminSupportAnnouncementsComponent;